import { getTaskTemplateForTaskId } from '../../../../../services/experiences/template';
import { findParentTaskTemplate } from './taskTemplateLookup';
import { IssueRaw, TimelineItemRef } from './types';

/**
 * The template-level timeline item an issue belongs to, in the form the
 * details page's `timelineItemId` selection understands. `null` when the
 * family has no item (missing supporting actor is instance-level) or the
 * item can't be resolved from the record.
 */
export const timelineItemRefFor = (raw: IssueRaw): TimelineItemRef | null => {
  if (raw.family === 'AUTOMATION') {
    return raw.automationTplId ? { type: 'automation', id: raw.automationTplId } : null;
  }
  if (raw.family === 'SENT_ITEM') {
    const { itemTplId, message } = raw.data;
    if (!itemTplId) return null;
    return { type: message.type === 'EXPERIENCE_MESSAGE' ? 'msg' : 'task', id: itemTplId };
  }
  if (raw.family === 'CC') {
    const { itemType, itemTplId } = raw.data;
    if (!itemTplId) return null;
    return { type: itemType === 'MESSAGE' ? 'msg' : 'task', id: itemTplId };
  }
  if (raw.family === 'ASSIGNEE_BOUNCE') {
    const { itemType, itemTplId, tpl, instance } = raw.data;
    if (!itemTplId) return null;
    if (itemType === 'MESSAGE') return { type: 'msg', id: itemTplId };
    // For tasks the record holds the task *instance* id, not the template id.
    const taskTplId = getTaskTemplateForTaskId(tpl, instance, itemTplId)?.id;
    return taskTplId ? { type: 'task', id: taskTplId } : null;
  }
  if (raw.family === 'INSTANCE_SUBTASK') {
    if ('automationTplId' in raw.data && raw.data.automationTplId) {
      return { type: 'automation', id: raw.data.automationTplId };
    }
    const { tpl, subtaskTplId } = raw.data;
    const taskTplId = subtaskTplId ? findParentTaskTemplate(tpl, subtaskTplId)?.id : undefined;
    return taskTplId ? { type: 'task', id: taskTplId } : null;
  }
  return null;
};
